/* Pick a Kit — flavour picker + variant resolver + add to cart.
   All markup and copy is server-rendered (sections/kkumi-pick-a-kit.liquid);
   this only swaps panels, resolves the chosen options to a variant, and adds
   it to the cart via the theme's own cart-drawer / cart-notification. */
(function () {
  function init(root) {
    if (root.dataset.kkBound) return;
    root.dataset.kkBound = '1';

    var d = root.dataset;
    var tabs = [].slice.call(root.querySelectorAll('[data-pk-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-pk-panel]'));
    var imgs = [].slice.call(root.querySelectorAll('[data-pk-img]'));
    var stage = root.querySelector('[data-pk-stage]');
    var fotm = root.querySelector('[data-pk-fotm]');
    var counter = root.querySelector('[data-pk-count]');
    if (!tabs.length || !panels.length) return;
    var cur = -1;

    function money(cents) {
      return window.KKMoney.fromCents(cents);
    }

    /* ---- per-panel variant resolution ---- */
    function state(panel) {
      if (!panel._pk) {
        var el = panel.querySelector('[data-pk-variants]');
        var list = [];
        try { list = JSON.parse(el ? el.textContent : '[]'); } catch (e) { list = []; }
        panel._pk = { variants: list, groups: [].slice.call(panel.querySelectorAll('[data-pk-option]')) };
      }
      return panel._pk;
    }

    function selection(st) {
      return st.groups.map(function (g) {
        /* card groups are radios; the Dropdown picker style is a <select> */
        var r = g.querySelector('input:checked') || g.querySelector('[data-pk-select]');
        return r ? r.value : null;
      });
    }

    /* ---- Simple Bundles options (kkumi-sb-options inside the panel) ----
       Cards + hidden inputs are owned by kkumi-sb-options.js; this only reads
       them: the picks for the summary, a problem to block the add on, and the
       properties[…] inputs it wrote into [data-pk-props]. */
    function sbEntries(panel) {
      return [].slice.call(panel.querySelectorAll('[data-kk-sb-scope] [data-kk-sb-entry]'));
    }

    function sbPicks(panel) {
      return sbEntries(panel).map(function (el) {
        if (el.hasAttribute('data-kk-sb-fixed')) return null;
        var c = el.querySelector('[data-kk-sb-input]:checked');
        return c ? String(c.value).split('(')[0].trim() || c.value : null;
      });
    }

    function sbProblem(panel) {
      var list = sbEntries(panel);
      for (var i = 0; i < list.length; i++) {
        var el = list[i];
        var label = el.dataset.kkSbLabel || el.dataset.kkSbName || '';
        if (el.hasAttribute('data-kk-sb-fixed')) {
          if (el.hasAttribute('data-kk-sb-soldout')) return { el: el, label: label, kind: 'soldout' };
          continue;
        }
        if (el.querySelector('[data-kk-sb-input]:checked:not(:disabled)')) continue;
        var open = el.querySelector('[data-kk-sb-input]:not(:disabled)');
        return { el: el, label: label, kind: open ? 'choose' : 'soldout' };
      }
      return null;
    }

    function find(st, sel) {
      for (var i = 0; i < st.variants.length; i++) {
        var v = st.variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && String(v.options[j]).trim() !== sel[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function sync(panel) {
      var st = state(panel);
      var sel = selection(st);
      var variant = st.groups.length ? find(st, sel) : st.variants[0];
      var priceEl = panel.querySelector('[data-pk-price]');
      var add = panel.querySelector('[data-pk-add]');
      var addLabel = panel.querySelector('[data-pk-add-label]');
      var err = panel.querySelector('[data-pk-error]');
      if (err) err.hidden = true;

      /* card sub-lines + availability, evaluated against the other selections */
      st.groups.forEach(function (g, gi) {
        var radios = [].slice.call(g.querySelectorAll('input[type=radio]'));
        var prices = radios.map(function (r) {
          var s2 = sel.slice(); s2[gi] = r.value;
          var v = find(st, s2);
          return v ? v.price : null;
        });
        var differs = prices.some(function (p) { return p !== null && p !== prices[0]; });
        radios.forEach(function (r, ri) {
          var s2 = sel.slice(); s2[gi] = r.value;
          var v = find(st, s2);
          var label = r.closest('.var-option');
          var sub = label.querySelector('[data-pk-sub]');
          var text = '';
          if (differs && prices[ri] !== null) {
            text = ri === 0 ? money(prices[ri]) : (prices[ri] - prices[0] > 0 ? '+' + money(prices[ri] - prices[0]) : money(prices[ri]));
          }
          if (sub.textContent !== text) sub.textContent = text;
          label.classList.toggle('var-option--soldout', !v || !v.available);
        });
        var select = g.querySelector('[data-pk-select]');
        if (select) {
          [].slice.call(select.options).forEach(function (o) {
            var s2 = sel.slice(); s2[gi] = o.value;
            var v = find(st, s2);
            /* never disable the current pick, or the select would show blank */
            var off = (!v || !v.available) && o.value !== sel[gi];
            if (o.disabled !== off) o.disabled = off;
          });
        }
        var val = g.querySelector('[data-pk-val]');
        if (val && sel[gi] !== null && val.textContent !== sel[gi]) val.textContent = sel[gi];
      });

      /* folded options row: live summary; open it when the pick can't be bought */
      var custom = panel.querySelector('[data-pk-custom]');
      if (custom) {
        var sumEl = custom.querySelector('[data-pk-optsum]');
        var sum = sbPicks(panel).concat(sel).filter(Boolean).join(' \u00b7 ');
        if (sumEl && sumEl.textContent !== sum) sumEl.textContent = sum;
        if ((!variant || !variant.available) && !custom.open) custom.open = true;
      }

      if (variant && priceEl) priceEl.textContent = money(variant.price);

      /* tweezers line */
      var tw = panel.querySelector('[data-pk-tweezers]');
      if (tw) {
        var kw = (d.tweezersKeyword || '').toLowerCase();
        var has = !!(kw && variant && variant.options.some(function (o) { return String(o).toLowerCase().indexOf(kw) > -1; }));
        tw.hidden = !has;
      }

      /* add button */
      var sbp = sbProblem(panel);
      if (add) {
        var label, disabled = false;
        if (!variant) { label = d.unavailableLabel; disabled = true; }
        else if (!variant.available || (sbp && sbp.kind === 'soldout')) { label = d.soldOutLabel; disabled = true; }
        else label = d.addLabel;
        add.dataset.variant = variant ? variant.id : '';
        add.disabled = disabled;
        if (addLabel && addLabel.textContent !== label) addLabel.textContent = label;
      }
    }

    /* ---- flavour selection ---- */
    function pick(i, focus) {
      if (i === cur) return;
      var prev = cur >= 0 ? panels[cur] : null;
      var prevSel = prev ? selection(state(prev)) : null;
      cur = i;

      tabs.forEach(function (t, x) {
        t.setAttribute('aria-selected', x === i ? 'true' : 'false');
        t.tabIndex = x === i ? 0 : -1;
      });
      panels.forEach(function (p, x) { p.hidden = x !== i; });
      imgs.forEach(function (im) { im.classList.toggle('is-on', im.dataset.pkImg === String(i)); });

      var tab = tabs[i];
      if (stage && tab.dataset.soft) stage.style.setProperty('--soft', tab.dataset.soft);
      if (fotm) fotm.hidden = tab.dataset.fotm !== 'true';
      if (counter) counter.textContent = (i + 1) + ' / ' + tabs.length;

      /* keep the same option values where the new product has them */
      var panel = panels[i], st = state(panel);
      if (prev) {
        /* Simple Bundles picks carry over by option name; `change` lets
           kkumi-sb-options.js rewrite this panel's properties. */
        var prevSb = {};
        sbEntries(prev).forEach(function (el) {
          var c = el.querySelector('[data-kk-sb-input]:checked');
          if (c) prevSb[el.dataset.kkSbName] = c.value;
        });
        sbEntries(panel).forEach(function (el) {
          var want = prevSb[el.dataset.kkSbName];
          if (want == null) return;
          var match = [].slice.call(el.querySelectorAll('[data-kk-sb-input]')).filter(function (r) { return r.value === want; })[0];
          if (match && !match.disabled && !match.checked) {
            match.checked = true;
            match.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
      if (prevSel) {
        st.groups.forEach(function (g, gi) {
          if (prevSel[gi] == null) return;
          var select = g.querySelector('[data-pk-select]');
          if (select) {
            var opt = [].slice.call(select.options).filter(function (o) { return o.value === prevSel[gi]; })[0];
            if (opt && !opt.disabled) select.value = opt.value;
            return;
          }
          var radios = [].slice.call(g.querySelectorAll('input[type=radio]'));
          var match = radios.filter(function (r) { return r.value === prevSel[gi]; })[0];
          if (match && !match.closest('.var-option--soldout')) match.checked = true;
        });
      }
      sync(panel);
      if (focus) tab.focus();
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(i); });
    });
    root.querySelector('[data-pk-grid]').addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      pick((cur + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length, true);
    });

    root.addEventListener('change', function (e) {
      var panel = e.target.closest && e.target.closest('[data-pk-panel]');
      if (panel && (e.target.type === 'radio' || e.target.matches('[data-pk-select]'))) sync(panel);
    });

    /* ---- add to cart ---- */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pk-add]');
      if (!btn || btn.disabled || !btn.dataset.variant) return;
      var panel = btn.closest('[data-pk-panel]');
      var err = panel.querySelector('[data-pk-error]');
      var p = sbProblem(panel);
      if (p) {
        var custom = panel.querySelector('[data-pk-custom]');
        if (custom) custom.open = true;
        if (err) {
          err.textContent = String((p.kind === 'soldout' ? d.sbSoldOutLabel : d.chooseLabel) || d.errorLabel).replace(/\[option\]/g, p.label);
          err.hidden = false;
        }
        var target = p.el.querySelector('[data-kk-sb-input]:not(:disabled)');
        if (target) target.focus();
        return;
      }
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = new FormData();
      body.append('id', btn.dataset.variant);
      body.append('quantity', '1');
      /* Simple Bundles choices: properties[<option>] + properties[_bundle_selection] */
      [].slice.call(panel.querySelectorAll('[data-pk-props] input')).forEach(function (input) {
        if (input.name && input.value) body.append(input.name, input.value);
      });
      if (cart) {
        body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        body.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }
      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = body;

      if (err) err.hidden = true;
      window.KKBtn.busy(btn, d.addingLabel);
      fetch(window.routes.cart_add_url, config)
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            if (err) { err.textContent = res.description || d.errorLabel; err.hidden = false; }
            return;
          }
          if (!cart) { window.location = window.routes.cart_url; return; }
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pick-a-kit', productVariantId: btn.dataset.variant, cartData: res });
          }
          cart.renderContents(res);
        })
        .catch(function () {
          if (err) { err.textContent = d.errorLabel; err.hidden = false; }
        })
        .finally(function () {
          window.KKBtn.reset(btn);
          sync(panel);
        });
    });

    pick(0);
  }

  function boot(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-kk-pick-a-kit]')).forEach(init);
  }
  boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
